import React from 'react';
import { TreeReferencesContextProvider } from '../../../../tree/references/TreeReferencesContext';
import { TreeReferencesGlobalContextProvider } from '../../../../tree/references/TreeReferencesGlobalContext';
import { IReference } from '../../../expressions/references/IReference';
import { IAsyncService } from '../../../expressions/repository/async/context/IAsyncService';
import { Widget } from '../../Widget';
import { storybookTestTree } from './testTrees';

interface IDecorateWithEditorExpressionOptions {
  otherReferences?: IReference[];
  services?: IAsyncService[];
}

/**
 * Imposta un contesto di TreeReferenceEditor indicando che siamo nel Widget
 * indicato.
 * Attenzione! Permette solo di usare i widget in `storybookTestTree`.
 */
export function decorateWithEditorExpressionAndWidget(
  widget: Widget,
  options: IDecorateWithEditorExpressionOptions = {},
) {
  // eslint-disable-next-line react/display-name
  return (Story: any) => (
    <TreeReferencesGlobalContextProvider
      allRoots={[{ id: '1', root: storybookTestTree, type: 'section' }]}
      selectedRootId="1"
      otherReferences={options.otherReferences ?? []}
      async={{
        services: options.services ?? [],
      }}
    >
      <TreeReferencesContextProvider widget={widget} root={storybookTestTree}>
        <Story />
      </TreeReferencesContextProvider>
    </TreeReferencesGlobalContextProvider>
  );
}

export function decorateWithEditorExpression(
  options: IDecorateWithEditorExpressionOptions = {},
) {
  // eslint-disable-next-line react/display-name
  return (Story: any) => (
    <TreeReferencesGlobalContextProvider
      allRoots={[{ id: '1', root: storybookTestTree, type: 'section' }]}
      selectedRootId="1"
      otherReferences={options.otherReferences ?? []}
      async={{
        services: [],
      }}
    >
      <Story />
    </TreeReferencesGlobalContextProvider>
  );
}
